import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { Button } from '@smartplatform/ui';
import DeputyPopup from './DeputyPopup';
import store from '../../store';

export const positions = {
	0: 'член комитета',
	1: 'заместитель председателя',
	2: 'председатель комитета'
};

@observer
export default class Members extends React.Component {

	@observable records = [];
	@observable error = null;
	@observable deputyPopup = null;

	constructor(props) {
		super(props);
		this.sendProps = { ...props, onClose: this.closePopup, onChange: this.init };
		this.onDeputiesChange = this.props.onDeputiesChange;
		this.init();
	}

	init = async () => {
		try {
			this.records = await store.model.DeputyCommittee.find({
				where: { committeeId: this.props.committee.id, deputyId: { neq: null } },
				include: [
					{
						relation: 'deputy',
						scope: {
							fields: { id: true, lastName: true, firstName: true, middleName: true }
						}
					}
				],
				order: 'id asc',
			});
		}
		catch (e) {
			this.error = e.message;
		}
	};

	showAddPopup = () => {
		this.deputyPopup = <DeputyPopup {...this.sendProps} />;
	};

	showEditPopup = (e, deputyCommittee) => {
		e.preventDefault();
		this.deputyPopup = <DeputyPopup {...this.sendProps} deputyCommittee={deputyCommittee} />;
	};

	closePopup = async () => {
		const deputiesCount = await this.props.committee.deputies.count();
		this.onDeputiesChange(deputiesCount);
		this.deputyPopup = null;
	};

	render() {
		let content = '...';

		if (this.error) {
			content = this.error;
		}
		else if (this.records) {
			const deputies = this.records.map(depCom => {
				const { deputy } = depCom;
				return <tr key={deputy.id}>
					<td className="fio">{deputy.lastName} {deputy.firstName} {deputy.middleName}</td>
					{/*<td className="position">{depCom.position || '-'}</td>*/}
					<td className="position">{positions[depCom.positionNum || 0]}</td>
					{/*<td className="comment">{depCom.comment || '-'}</td>*/}
					<td className="actions"><a href="#" onClick={e => this.showEditPopup(e, depCom)}>Редактировать</a></td>
				</tr>;
			});
			content = <>
				<table>
					<thead>
					<tr>
						<th>Ф.И.О.</th>
						{/*<th>Должность</th>*/}
						<th>Должность</th>
						{/*<th>Примечание</th>*/}
						<th>Действия</th>
					</tr>
					</thead>
					<tbody>{deputies}</tbody>
				</table>
				<p>
					<Button onClick={this.showAddPopup}>Добавить</Button>
				</p>
			</>;
		}

		return <div className="form-field committee-deputies">
			<label>Члены комитета</label>
			{content}
			{this.deputyPopup}
		</div>;
	}

}
